import { logger } from '../utils/logger.js';

/**
 * Widget Messaging - Communication avec le parent (pour iframe)
 */
export const WidgetMessaging = {
  isWidgetMode: function () {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('widget') === 'true';
  },

  sendToParent: function (type, data) {
    if (window.parent && window.parent !== window) {
      try {
        window.parent.postMessage(
          {
            type,
            data,
            source: 'ringado-widget',
          },
          '*'
        );
      } catch (error) {
        logger.error('Error sending message to parent:', error);
      }
    }
  },

  signalChatOpened: function () {
    this.sendToParent('CHAT_OPENED');
  },

  signalChatClosed: function () {
    this.sendToParent('CHAT_CLOSED');
  },

  initWidgetCommunication: function () {
    if (!this.isWidgetMode()) return;

    const messageHandler = (event) => {
      if (event.data?.source !== 'ringado-parent') return;

      switch (event.data.type) {
        case 'CLOSE_CHAT':
          if (window.RingadoChatWidget?.instance)
            window.RingadoChatWidget.instance.closeChat();
          break;
        case 'OPEN_CHAT':
          if (window.RingadoChatWidget?.instance)
            window.RingadoChatWidget.instance.openChat();
          break;
      }
    };

    window.addEventListener('message', messageHandler);
  },
};
